import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NgwService } from '../../app/ngw.service';
import { NgwPlayer, NgwGame } from '../../app/classes/ngwGame';


@Component({
 
  templateUrl: 'starredStandings.html',
})
export class StarredStandings implements OnInit  {
 players:NgwPlayer[];

  constructor(public navCtrl: NavController, public navParams: NavParams, public ngwService: NgwService) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Standings');
  }


  ngOnInit(): void {
    this.players = [];
    
    this.ngwService.games.forEach((game) => {
      if(game.starred)
      {
        game.players.forEach((player) => {
          if(player.balance)
          {
            let currPlayer = this.players.find(val => val.name == player.name);
            if (currPlayer)
              currPlayer.balance += player.balance;
            else
              this.players.push(Object.assign({}, player))
          }
        })
      }
    })

      
  }

}




// WEBPACK FOOTER //
// ./src/pages/starredStandings/starredStandings.ts